import { createContext, useContext } from 'react';

interface StoryblokFormContextValue {
    readonly?: boolean;
}

export const StoryblokFormContext = createContext<StoryblokFormContextValue>({
    readonly: false,
});

export const useStoryblokContext = () => useContext(StoryblokFormContext);
